import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_102_6350)\"><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M4.28137 5.99141H21.3139M17.686 3.34738V8.81991\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M4.28137 18.6583H21.3139M17.686 16.0143V21.4868\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M21.314 12.5093L4.28148 12.5093M7.90934 15.1533L7.90934 9.68076\"></path></g><defs><clipPath id=\"clip0_102_6350\"><rect width=\"24\" height=\"24\" fill=\"currentColor\" transform=\"translate(0.643555)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "filter"}) } }